export const movPdfGenerator = {
    endpoints: {
        acceptance: 'wss://j24vf9sub0.execute-api.us-east-1.amazonaws.com/acceptance',
        prod: 'wss://najksdkx75.execute-api.us-east-1.amazonaws.com/prod',
        test: 'wss://c2sa43bpif.execute-api.us-east-1.amazonaws.com/test',
    },
    http: {},
};
